"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.triggerBalanceByCurrency = void 0;
exports.triggerBalanceByCurrency = {
    USD: 0.5,
    EUR: 0.5,
    GBP: 0.5,
    AUD: 0.5,
    CAD: 0.5,
    NZD: 0.5,
    RUB: 30,
    PLN: 2,
    KZT: 200,
};
